import React, { Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
import { useAxiosInterceptors } from '../hooks/useAxiosInterceptors';
import { useInitialization } from '../hooks/useInitialization';
import 'react-toastify/dist/ReactToastify.css';
import Routes from '../routes';
import Loading from '../components/loading';

function Root() {
  const { loading } = useInitialization();
  if (loading) return <Loading />;
  return (
    <Suspense fallback={'loooooading'}>
      <ToastContainer />
      <Routes />
    </Suspense>
  );
}

export default Root;
